import React from "react";
import SearchableSelectInput from "../../input/searchable-select-input";

const MultiSelect1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data };
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-center h-full w-full">
      {widget && (
        <SearchableSelectInput
          valueSpec={widget}
          onChange={handleValueUpdate}
          onError={() => {}}
          multiSelect={true}
          style="compact"
        />
      )}
    </div>
  );
};

export default MultiSelect1Widget;
